import React, { ReactElement, useEffect, useRef, useState } from "react";
import styles from './AudioBlock.module.scss';
import { IAudio } from "@common/redux/types/common";
import classNames from "classnames";
import Slider from "rc-slider";
import { useAudio } from "@kursk/context/audio.context";

interface IProps {
  audio: IAudio;
  className?: string;
}

export const AudioBlock = ({ audio, className }: IProps): ReactElement => {
  const [duration, setDuration] = useState(audio.duration);
  const [curTime, setCurTime] = useState(0);
  const [playing, setPlaying] = useState(false);
  const [clickedTime, setClickedTime] = useState(null);
  const forAudio = useRef(null);
  const { setAudio, getAudio } = useAudio();
  useEffect(() => {
    // если переключили аудио
    if (getAudio !== forAudio?.current) {
      setPlaying(false);
      forAudio?.current?.pause();
    }
  })

  useEffect(() => {
    const audio: any = forAudio.current;
    playing ? audio.play() : audio.pause();
    // если кликнули на полоску с музыкой
    if (clickedTime && clickedTime !== curTime) {
      audio.currentTime = clickedTime;
      setClickedTime(null);
    }
    // если аудио закончилось
    if (Math.floor(audio.currentTime) === Math.floor(audio.duration)) {
      setPlaying(false);
      audio.pause();
      audio.currentTime = 0;
      setCurTime(audio.currentTime);
    }
  }, [clickedTime, playing]);

  useEffect(() => {
    const audio: any = forAudio.current;
    const setAudioData = () => {
      setDuration(Math.floor(audio.duration));
      setCurTime(audio.currentTime);
    }
    const setAudioTime = () => setCurTime(audio.currentTime);
    audio.addEventListener("loadeddata", setAudioData);
    audio.addEventListener("timeupdate", setAudioTime);
    return () => {
      audio.removeEventListener("loadeddata", setAudioData);
      audio.removeEventListener("timeupdate", setAudioTime);
    }
  }, [forAudio.current])

  function formatDuration(duration: number): string {
    const minutes = Math.trunc((duration/60));
    const seconds = Math.floor(duration % 60);
    if (seconds.toString().length === 1) {
      return `${minutes}:0${seconds}`
    }
    return `${minutes}:${seconds}`
  }

  const playAudio = () => {
    if (forAudio.current) {
      setAudio(forAudio.current);
      setPlaying(!playing);
    }
  }
  const onProgressBarChange = (value) => {
    setClickedTime(value);
  }

  return (
    <div className={classNames([styles.player, className && className])}>
      <audio ref={forAudio} loop={false}>
        <source src={`/uploads/${audio.name}`} />
                Your browser does not support the <code>audio</code> element.
      </audio>
      <div className={styles.controls}>
        <button className={styles.player__button} onClick={() => playAudio()}>
          <div className={classNames([styles.player__icon, playing && styles.paused])}/>
        </button>
        <div className={styles.bar}>
          <Slider
            min={0}
            max={Math.floor(audio.duration)}
            defaultValue={0}
            value={curTime}
            onChange={value => onProgressBarChange(value)}/>
          <div className={styles.bar__info}>
            <span className={styles.bar__time}>{formatDuration(curTime)}</span>
            <span className={styles.bar__time}>{formatDuration(duration)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
